import withContainer from './container';
import EventInfoHeader from './view';

export default withContainer(EventInfoHeader);
